"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDesigner = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const mithril_component_1 = require("../../components/mithril.component");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const store_1 = require("../../store");
const form_field_editor_1 = require("./editor/form.field.editor");
const form_field_editor_form_1 = require("./editor/form.field.editor.form");
const form_field_editor_height_1 = require("./editor/form.field.editor.height");
const form_field_editor_nested_list_1 = require("./editor/form.field.editor.nested.list");
const form_field_editor_select_list_1 = require("./editor/form.field.editor.select.list");
const form_field_editor_subform_1 = require("./editor/form.field.editor.subform");
const form_field_editor_vertical_separation_1 = require("./editor/form.field.editor.vertical.separation");
const form_designer_style_1 = require("./form.designer.style");
(0, theme_1.addStyles)(form_designer_style_1.Style);
class FormDesigner extends mithril_component_1.IMithrilStateComponent {
    constructor() {
        super();
        this.isEditing = false;
        this.isSaving = false;
        this.selectedFieldId = null;
        this.scrollToFieldId = null;
        this.fields = {};
        services_1.Services.Window.bindNavigateAway(i18n_1.T.DISCARD_CHANGES_CONFIRM, this.checkExit);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: `${form_designer_style_1.CSS.container} ${this.isEditing ? form_designer_style_1.CSS.isEditing : form_designer_style_1.CSS.isReadOnly}` }, [
            this.viewHeader(),
            (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.content }, [
                this.viewFields(),
                this.viewInfo()
            ])
        ]);
    }
    onRemove() {
        super.onRemove();
        services_1.Services.Window.unbindNavigateAway(this.checkExit);
        const editState = this.editState;
        if (editState != null) {
            this.editState.destroy();
        }
    }
    setForm(form) {
        this.form = store_1.AppStore.Form.edit(form).form;
        // After saving a new form, clear the edit state.
        // Use the new form edit state despite the versions being the same.
        if (this.form.id == null && form.id != null) {
            store_1.AppStore.Form.clearEdit(form);
            this.form = store_1.AppStore.Form.edit(form).form;
        }
        this.reset();
    }
    setEditing(isEditing) {
        this.isEditing = isEditing;
    }
    get editState() {
        if (this.isEditing) {
            return store_1.AppStore.Form.edit(this.form);
        }
        return null;
    }
    viewHeader() {
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.header }, [
            (0, mithril_1.m)('h6', (0, i18n_1.Translate)(i18n_1.T.FORM_EDIT_TITLE)),
            (0, mithril_1.m)('button', {
                className: 'mdl-button mdl-button--raised mdl-button--accent',
                disabled: !this.canSave,
                onclick: () => this.save()
            }, this.isSaving ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.SAVE))
        ]);
    }
    viewFields() {
        const form = this.form;
        if (this.selectedFieldId == null) {
            this.selectedFieldId = form.fieldId;
        }
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.field.container }, this.viewField(form));
    }
    viewInfo() {
        if (this.selectedFieldId == null || this.fields[this.selectedFieldId] == null) {
            return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.info.container });
        }
        return (0, mithril_1.m)('div', { className: form_designer_style_1.CSS.info.container }, this.fields[this.selectedFieldId].viewInfo());
    }
    createEditor(f) {
        if (f === this.form) {
            return new form_field_editor_form_1.FormFieldEditorForm(this, f);
        }
        if (core_shared_1.FormModelFieldSubForm.isSubForm(f)) {
            return new form_field_editor_subform_1.FormFieldEditorSubForm(this, f);
        }
        if (core_shared_1.FormModelFieldNestedList.isNestedList(f)) {
            return new form_field_editor_nested_list_1.FormFieldEditorNestedList(this, f);
        }
        if (core_shared_1.FormModelFieldSelectList.isSelectList(f)) {
            return new form_field_editor_select_list_1.FormFieldEditorSelectList(this, f);
        }
        if (f.type === core_api_1.IkeFieldType.HEIGHT) {
            return new form_field_editor_height_1.FormFieldEditorHeight(this, f);
        }
        if (f.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            return new form_field_editor_vertical_separation_1.FormFieldEditorVerticalSeparation(this, f);
        }
        return new form_field_editor_1.FormFieldEditor(this, f);
    }
    createField(form, type) {
        const field = form.Mutator.create(type, core_shared_1.IkeId.generate());
        this.setSelected(field);
        this.setScrollToField(field);
    }
    setScrollToField(field) {
        if (field == null) {
            this.scrollToFieldId = null;
        }
        else {
            this.scrollToFieldId = field.fieldId;
        }
    }
    reset() {
        if (this.isEditing) {
            this.editState.reset();
        }
        for (const fieldId of Object.keys(this.fields)) {
            const fieldState = this.fields[fieldId];
            fieldState.state.destroy();
        }
        this.fields = {};
        this.setSelected(this.form);
    }
    get canSave() {
        if (this.isEditing) {
            return this.editState.isDirty && !this.isSaving && this.editState.canSubmit;
        }
        return false;
    }
    checkExit() {
        return this.editState.isDirty;
    }
    getEditor(f) {
        let editor = this.fields[f.fieldId];
        if (editor == null) {
            editor = this.fields[f.fieldId] = this.createEditor(f);
            this.editState.inputStates.add(editor.state);
        }
        return editor;
    }
    viewField(f) {
        const nodes = this.getEditor(f).viewTree();
        if (this.scrollToFieldId === f.fieldId) {
            nodes.attrs.oncreate = (ctx) => {
                ctx.dom.scrollIntoView();
                this.setScrollToField(null);
            };
        }
        return nodes;
    }
    setSelected(f) {
        if (f == null) {
            this.selectedFieldId = null;
        }
        else {
            this.selectedFieldId = f.fieldId;
        }
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.editState == null || !this.canSave) {
                return;
            }
            this.setSaving(true);
            let selectedFieldId = null;
            if (this.selectedFieldId != null) {
                selectedFieldId = this.selectedFieldId.split(':').pop();
            }
            try {
                const isNewForm = this.form.id == null;
                const newForm = yield services_1.Services.Form.save(this.editState.form);
                this.setForm(newForm);
                if (isNewForm) {
                    services_1.Services.Route.go(page_1.IkePageName.formEdit, { version: newForm.version });
                }
                else {
                    services_1.Services.Route.setParam('version', newForm.version);
                    if (selectedFieldId != null) {
                        const selectedField = newForm.findField(selectedFieldId);
                        this.setSelected(selectedField);
                    }
                }
            }
            catch (e) {
                notification_service_1.NotificationService.error({ key: i18n_1.T.FORM_ERROR_SAVING });
                services_1.Services.Log.Logger.error(e);
            }
            this.setSaving(false);
        });
    }
    setSaving(isSaving) {
        this.isSaving = isSaving;
    }
}
exports.FormDesigner = FormDesigner;
tslib_1.__decorate([
    mobx_1.observable
], FormDesigner.prototype, "isEditing", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormDesigner.prototype, "isSaving", void 0);
tslib_1.__decorate([
    mobx_1.observable.ref
], FormDesigner.prototype, "form", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormDesigner.prototype, "selectedFieldId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormDesigner.prototype, "scrollToFieldId", void 0);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "setForm", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "setEditing", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "createField", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "setScrollToField", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormDesigner.prototype, "checkExit", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "setSelected", null);
tslib_1.__decorate([
    mobx_1.action
], FormDesigner.prototype, "setSaving", null);
//# sourceMappingURL=form.designer.js.map